import React from 'react'
import { Helmet } from 'react-helmet'
// import { Link } from 'gatsby'

import SalesBoost from '../../components/contact-boost'
import Layout from '../../layout/layout'
import WatchVideo from '../../components/watch-video'

import Retailer from '../../svg/street-with-retailer.svg'
import Collaboration from '../../svg/retailer-collaboration.svg'
import Simple from '../../svg/simple.svg'
import Retailerassortment from '../../svg/retailer-assortment.svg'
import WatchVideoWithPlaceholder from '../../components/watch-video-with-placeholder'

const Page = () => (

    <Layout>

        <Helmet>
          <title>Retailers - Meer klanten, meer omzet</title>
          <meta name="description" content="Met Zupr laat u consumenten online zien waar producten in lokale, fysieke winkels verkrijgbaar zijn." />
        </Helmet>

        <section className="city retailer">
            <h1>Uw assortiment online zonder webshop</h1>
            <WatchVideo id="4S_tWVxrAzQ">
                Bekijk video
            </WatchVideo>
            <a className="btn btn-demo" href="mailto:demo@zupr.io?subject=Ik wil graag een demo">Vraag demo aan</a>
            <div className="background">
                <Retailer />
            </div>
        </section>

        <section className="text-center divider">
            <div className="inner">
                <div className="text">
                    <h2>Online vinden, lokaal kopen</h2>
                    <p>Veel consumenten hebben voorkeur voor lokale, fysieke winkels. Vanwege het persoonlijke contact, het goede advies, de mogelijkheid om producten eerst te kunnen beoordelen en natuurlijk om een product meteen mee te kunnen nemen als het bevalt. In deze huidige tijden is het prettig als u uw klanten ook op andere manieren kunt bedienen. Kijk <a href="/nl/aanmelden">hier</a> voor de mogelijkheden om online betalen en direct bezorgen mogelijk te maken.</p>
                </div>

            </div>
        </section>

        <section className="text-center">
            <div className="inner">
                <div className="text">
                    <h2>Probeer Zupr gratis</h2>
                    <p>Start vandaag nog met Zupr en ontdek de voordelen</p>
                    <a rel="noopener noreferrer" className="btn btn-demo" href="/nl/app/">Maak een gratis account aan</a>
                </div>
            </div>
        </section>

        <section className="text-right grey">
            <div className="inner">
                <div className="text">
                    <h2>Online vindbaar zonder webshop</h2>
                    <p>Waar producten in de buurt te koop zijn, is online vaak lastig te achterhalen. Consumenten die offline willen kopen, moeten hun aanschaf dan alsnog online doen.</p>
                    <p>Door via Zupr aan te geven wat u verkoopt, kunnen consumenten direct zien welke producten en merken er lokaal verkrijgbaar zijn. U bepaalt zelf voor welke producten u gevonden wilt worden en de mate waarin voorraad- en prijsinformatie aan consumenten wordt getoond. In het simpelste geval kiest u ervoor geen voorraad en prijzen weer te geven. De consument kan daarover dan rechtstreeks contact met u opnemen. De video laat zien hoe u met behulp van de app eenvoudig producten toont en bestellingen afhandelt.</p>
                </div>
                <div className="image">
                    <WatchVideoWithPlaceholder id="qJwH8k1eolc" image="meet-with-zupr.png">
                    </WatchVideoWithPlaceholder>
                </div>
            </div>
        </section>

        <section className="text-center zupr-customers">
            <div className="inner">
                <div className="text">
                    <h3>Deze merken zijn al Zupr</h3>
                    <p>Bekijk de <a href="/nl/quickstart/#productinformatie-afkomstig-van-merken">quickstart pagina</a> voor retailers om te zien hoeveel producten we van uw merk(en) in de database hebben staan! Mocht u als merk uw data toe willen voegen dan biedt Zupr diverse mogelijkheden voor een <a href="/nl/datakoppeling/">datakoppeling</a>.</p>
                </div>
                <ul>
                    <li className="hk-living"></li>
                    <li className="nineninenine-games"></li>
                    <li className="via-vai"></li>
                    <li className="falke"></li>
                    <li className="pme-legend"></li>
                    <li className="lego"></li>
                    <li className="floris-van-bommel"></li>
                    <li className="jaques-britt"></li>
                </ul>
            </div>
        </section>

        <section className="text-center grey">
            <div className="inner">
                <div className="text">
                    <h2>Extra omzet zonder extra kosten</h2>
                    <p>Voor retailers is Zupr in de basis gratis te gebruiken. U meldt uw verkooplocatie(s) aan bij Zupr, selecteert de producten die u verkoopt en bent direct vindbaar via de websites en campagnes van de bij Zupr aangesloten merken.</p>
                    <p>Benieuwd naar onze tarieven? Klik op de onderstaande knop voor een overzicht van onze tarieven.</p>
                    <a rel="noopener noreferrer" className="btn btn-default brand" href="/nl/tarieven/">Bekijk onze tarieven</a>
                </div>
            </div>
        </section>

        <section className="text-left divider image-bottom">
            <div className="inner">
                <div className="text">
                    <h2>Samenwerken met merken via &eacute;&eacute;n platform</h2>
                    <p>Niets is minder efficiënt dan continue dezelfde informatie te moeten verstrekken aan verschillende partijen of met portals van verschillende merken te moeten werken.</p>
                    <p>Bij Zupr aangesloten merken voegen zelf hun producten toe. U hoeft dus niet zelf productinformatie en afbeeldingen in te voeren. U selecteert slechts wat u verkoopt. Merken hebben op hun beurt altijd accurate data over uw verkooppunt (openingstijden, betaalmethoden, contactgegevens, etc.), omdat u deze zelf beheert. En zo krijgt de consument altijd de juiste informatie over producten en locaties waar ze verkocht worden.</p>
                </div>

                <div className="image">
                    <Collaboration />
                </div>

            </div>
        </section>

        <section className="text-right divider">
            <div className="inner">

                <div className="text">
                    <h2>Simpel in gebruik</h2>
                    <p>Bij Zupr hebben we als uitgangspunt dat iedere retailer online vindbaar moet kunnen zijn. Ook retailers zonder website of webshop. Om die reden is het platform zo gemaakt dat de gegevens over uw verkooplocatie en assortiment heel eenvoudig en met de hand bijgehouden kunnen worden. Daarnaast is er een speciale retailer app die u via uw smartphone of tablet kunt gebruiken. U kunt Zupr dus inzetten zonder dat u uw huidige processen hoeft aan te passen.</p>
                    <p>Uw bestaande product- of voorraadsysteem kan worden gekoppeld aan het Zupr-platform. Op die manier kunt u de prijzen en/of voorraad van uw producten geautomatiseerd updaten. Consumenten kunnen dan direct zien of een product op voorraad is en voor welke prijs, wat de kans op verkoop verhoogt. Ook vermindert dit het aantal klantvragen dat hierover binnenkomt.</p>
                </div>

                <div className="image">
                    <Simple />
                </div>

            </div>
        </section>

        <section className="text-left divider">
            <div className="inner">

                <div className="text">
                    <h2>Het volledige assortiment aanbieden</h2>
                    <p>In tegenstelling tot online hebben fysieke winkels beperkte schapruimte en dus een beperkter assortiment. U kunt met merken of leveranciers afspreken een groter deel van hun assortiment te verkopen in uw winkel.</p>
                    <p>Dankzij Zupr kunt u het volledige assortiment van een merk aanbieden. Weliswaar niet fysiek in de winkel, maar het product wordt dan door het merk geleverd in uw winkel. Aangezien het product eigendom blijft van het merk bijt dit niet in uw inkoopbudget. Afrekenen gebeurt in de winkel. Daarbij kunt u uw klanten tegemoet komen door zonder aankoopverplichting een product in uw winkel te bekijken of te passen welke normaliter niet in het assortiment is opgenomen.</p>
                </div>

                <div className="image">
                    <Retailerassortment />
                </div>

            </div>
        </section>

        <SalesBoost />

    </Layout>
)

export default Page
